import * as React from 'react';
import {AnalyticsContext} from './createAnalyticsContext';

export const createUseAnalytics = <T extends string>(
  context: React.Context<AnalyticsContext<T>>,
) => {
  const useAnalytics = () => {
    const analyticsContext = React.useContext(context);
    return analyticsContext.analyticsReporter;
  };
  return useAnalytics;
};
